export const ANALYTICS_EVENTS = {
    PLUGIN_INITIALIZED: 'blockjam_plugin_initialized',
    PLUGIN_STARTED: 'blockjam_plugin_started',
    PLUGIN_PAUSED: 'blockjam_plugin_paused',
    PLUGIN_RESUMED: 'blockjam_plugin_resumed',
    PLUGIN_DESTROYED: 'blockjam_plugin_destroyed',
    SESSION_STARTED: 'blockjam_session_started',
    SESSION_ENDED: 'blockjam_session_ended',
    LEVEL_STARTED: 'blockjam_level_started',
    LEVEL_COMPLETED: 'blockjam_level_completed',
    LEVEL_RESTARTED: 'blockjam_level_restarted',
    // Daily Challenge (Module 67, WP-67.C1). Registered in
    // docs/Framework_Catalogs/Analytics_Master_Schema.md § BlockJam → Daily
    // Challenge before this code existed (rule 4).
    DAILY_STARTED: 'blockjam_daily_started',
    DAILY_COMPLETED: 'blockjam_daily_completed',
    DAILY_FAILED: 'blockjam_daily_failed',
    UNDO_USED: 'blockjam_undo_used',
    // Power-up lifecycle (WP-35.17). Registered in
    // docs/Framework_Catalogs/Analytics_Master_Schema.md § BlockJam → Power-Ups.
    POWERUP_UNLOCKED: 'blockjam_powerup_unlocked',
    POWERUP_ACTIVATED: 'blockjam_powerup_activated',
    POWERUP_COMPLETED: 'blockjam_powerup_completed',
    POWERUP_CAPPED: 'blockjam_powerup_capped',
    // Module 90 — Wild Gates closed unused (nothing charged), and the should-be-
    // unreachable charge failure at the exit that used it. Registered first.
    POWERUP_CANCELLED: 'blockjam_powerup_cancelled',
    POWERUP_CHARGE_FAILED: 'blockjam_powerup_charge_failed',
    // Module 144 (WP-144.1) — how the player answered the confirm card (Use, Not
    // now, a board tap, or the button again). Registered first (rule 4).
    POWERUP_CONFIRM_ANSWERED: 'blockjam_powerup_confirm_answered',
    // Module 45 (WP-45.3) — a tap on a power-up that has not unlocked. Registered
    // in docs/Framework_Catalogs/Analytics_Master_Schema.md § BlockJam → Power-Ups
    // before this code existed. It measures intent, not failure: the locked row is
    // on screen from level 1 to advertise the game's depth, and this is the only
    // evidence of whether it does.
    POWERUP_LOCKED_TAPPED: 'blockjam_powerup_locked_tapped',
    POWERUP_UNAFFORDABLE_TAPPED: 'blockjam_powerup_unaffordable_tapped',
    // Module 100 (WP-100.6) — each stage of the power-up unlock intro (card A,
    // demo B, landing C) as it completes, with the time spent on it. Registered
    // in docs/Framework_Catalogs/Analytics_Master_Schema.md § BlockJam →
    // Power-Ups before this code existed (rule 4).
    POWERUP_INTRO_STAGE_COMPLETED: 'blockjam_powerup_intro_stage_completed',
    // How to Play topic map (Module 101, WP-101.1/.4). Registered in
    // docs/Framework_Catalogs/Analytics_Master_Schema.md § BlockJam → Power-Ups
    // before this code existed (rule 4).
    HOWTO_TOPIC_VIEWED: 'blockjam_howto_topic_viewed',
    HOWTO_EXPLORED_REWARDED: 'blockjam_howto_explored_rewarded',
    // Rewarded ads (Module 41, WP-41.11/.12). Already registered in
    // docs/Framework_Catalogs/Analytics_Master_Schema.md § BlockJam → Ads, which
    // predates the code; the names and the `placement` param come from there.
    //
    // These are logged by the GAME, on every platform, because the game is what
    // decides to offer the reward — it just cannot offer it where the host
    // declares no `offerRewardedAd`. Nothing here knows what an ad network is.
    REWARD_AD_SHOWN: 'blockjam_reward_ad_shown',
    REWARD_AD_COMPLETED: 'blockjam_reward_ad_completed',
    REWARD_AD_FAILED: 'blockjam_reward_ad_failed',
    REWARD_DOUBLED: 'blockjam_reward_doubled',
    // Module 50 (WP-50.28a) — the move budget. Registered in
    // docs/Framework_Catalogs/Analytics_Master_Schema.md § BlockJam → Move budget
    // BEFORE this code existed (cross-cutting rule 4).
    //
    // The offer's own ad lifecycle is NOT duplicated here: watching, completing
    // and failing already have events, and the `placement: 'out_of_moves'` param
    // is what separates this placement from the other three. A parallel set of
    // budget-specific ad events would split one funnel across two vocabularies.
    MOVE_BUDGET_EXHAUSTED: 'blockjam_move_budget_exhausted',
    MOVE_BUDGET_GRANTED: 'blockjam_move_budget_granted',
    MOVE_BUDGET_AD_CAPPED: 'blockjam_move_budget_ad_capped',
    /** Module 80 (WP-80.16) — an attempt ended without a win: restarted or left. */
    LEVEL_FAILED: 'blockjam_level_failed',
    /** Module 80 (WP-80.17) — a rewarded "show next move" was paid out (Module 81: from the Hint button). */
    /** Module 81 (WP-81.4) — the 💡 Hint button was tapped (ad, none found, or used up). */
    /** Module 83 (WP-83.6) — the REVEAL button: tapped (every outcome), lit, the page shown, and closed. */
    REVEAL_TAPPED: 'blockjam_reveal_tapped',
    REVEAL_SHOWN: 'blockjam_reveal_shown',
    REVEAL_DONE: 'blockjam_reveal_done',
    /** Module 81 (WP-81.6) — the Hint button lit up: the player is about to run out of moves. */
    REVEAL_HIGHLIGHTED: 'blockjam_reveal_highlighted',
    // Module 59 (WP-59.9) — the HUD's derived dialog predicate, reported on every
    // transition. Registered in Analytics_Master_Schema.md § BlockJam → Dialogs
    // BEFORE this code existed (cross-cutting rule 4). Logged by the game on
    // every platform; embeds' composition holds the gameplay gate's 'modal'
    // blocker on it — the game never learns why anyone listens.
    DIALOG_OPENED: 'blockjam_dialog_opened',
    DIALOG_CLOSED: 'blockjam_dialog_closed',
    // Module 77 — registered in Analytics_Master_Schema.md § Help & Track
    // Guidance before the code that logs them.
    POWERED_HELP_OPENED: 'blockjam_powered_help_opened',
    /** Module 79 (WP-79.3) — the first-visit home tour ended. */
    HOME_TOUR_ENDED: 'blockjam_home_tour_ended',
    /** Module 147 (D6) — the one-time Home coach ended (`went_home` | `dismissed`). */
    HOME_COACH_ENDED: 'blockjam_home_coach_ended',
    // Module 79 (WP-79.9) — the Daily share: the tap, then how it ended.
    DAILY_SHARE_TAPPED: 'blockjam_daily_share_tapped',
    DAILY_SHARED: 'blockjam_daily_shared',
    TRACK_SUGGESTION_SHOWN: 'blockjam_track_suggestion_shown',
    TRACK_SUGGESTION_ACCEPTED: 'blockjam_track_suggestion_accepted',
    TRACK_SUGGESTION_DECLINED: 'blockjam_track_suggestion_declined',
    // Module 114 — the telemetry funnel's missing facts. Registered in
    // Analytics_Master_Schema.md § Telemetry Funnel before this code existed (rule 4).
    HOME_SHOWN: 'blockjam_home_shown',
    TRACK_SELECTED: 'blockjam_track_selected',
    FIRST_MOVE: 'blockjam_first_move',
    LANGUAGE_ANSWERED: 'blockjam_language_answered',
    COINS_CHANGED: 'blockjam_coins_changed',
    // Module 131 (WP-131.8) — a staged system's intro card was shown (it just unlocked).
    // Registered in Analytics_Master_Schema.md § Telemetry Funnel before this code (rule 4).
    FEATURE_UNLOCKED: 'blockjam_feature_unlocked',
    // Module 137 — a coin purchase's steps. Registered in Analytics_Master_Schema.md
    // § In-App Purchases before this code existed (rule 4).
    IAP: 'blockjam_iap',
    // Module 116 — the first-visit funnel. Registered in Analytics_Master_Schema.md
    // § First Visit Opens in Puzzle 1 before this code existed (rule 4).
    BOARD_SHOWN: 'blockjam_board_shown',
    ATTEMPT_MOVED: 'blockjam_attempt_moved',
    EARLY_MILESTONE_REACHED: 'blockjam_early_milestone_reached',
    LANGUAGE_CHANGED: 'blockjam_language_changed',
    // Module 118 — daily reward, quests and coin sinks. Registered in
    // Analytics_Master_Schema.md § Daily Reward, Quests & Coin Sinks before this
    // code existed (rule 4).
    DAILY_REWARD_SHOWN: 'blockjam_daily_reward_shown',
    DAILY_REWARD_CLAIMED: 'blockjam_daily_reward_claimed',
    STREAK_REPAIRED: 'blockjam_streak_repaired',
    QUESTS_OPENED: 'blockjam_quests_opened',
    QUEST_COMPLETED: 'blockjam_quest_completed',
    QUEST_CLAIMED: 'blockjam_quest_claimed',
    MOVES_BOUGHT: 'blockjam_moves_bought',
    DAILY_RETRIED: 'blockjam_daily_retried',
    MOVES_SHORT: 'blockjam_moves_short',
    // Module 132 (WP-132.8) — registered in Analytics_Master_Schema.md
    // § Milestones & Badges before this code existed (rule 4).
    MILESTONE_REACHED: 'blockjam_milestone_reached',
    // WP-132.9 — the rest of the Milestones & Badges family, same section.
    MILESTONE_CLAIMED: 'blockjam_milestone_claimed',
    MILESTONE_REVEALED: 'blockjam_milestone_revealed',
    MILESTONE_LINE_SHOWN: 'blockjam_milestone_line_shown',
    MILESTONE_TOAST_SHOWN: 'blockjam_milestone_toast_shown',
    BADGES_OPENED: 'blockjam_badges_opened',
    // WP-132.11 — replaces WP-132.9's status_changed: the title only ever goes up.
    TITLE_REACHED: 'blockjam_title_reached',
    // Module 133 (WP-133.5) — registered in Analytics_Master_Schema.md
    // § Daily Missions before this code existed (rule 4).
    MISSIONS_DRAWN: 'blockjam_missions_drawn',
    MISSIONS_OPENED: 'blockjam_missions_opened',
    MISSION_COMPLETED: 'blockjam_mission_completed',
    MISSION_CLAIMED: 'blockjam_mission_claimed',
    MISSION_BONUS_COLLECTED: 'blockjam_mission_bonus_collected',
    // Module 126 (WP-126.3) — registered in Analytics_Master_Schema.md
    // § Profile, Avatars & Sign-in before this code existed (rule 4).
    PROFILE_OPENED: 'blockjam_profile_opened',
    AVATAR_CHANGED: 'blockjam_avatar_changed',
    /** Module 152 (WP-152.2) — a coin avatar was unlocked. */
    AVATAR_PURCHASED: 'blockjam_avatar_purchased',
    /** Module 152 (WP-152.3) — "Set as my goal" on an Unlock card. */
    AVATAR_GOAL_SET: 'blockjam_avatar_goal_set',
    /** Module 152 (WP-152.3) — a new avatar wave was announced (home card) or opened. */
    AVATAR_WAVE_SEEN: 'blockjam_avatar_wave_seen',
    SIGN_IN_STARTED: 'blockjam_sign_in_started',
    SIGN_IN_COMPLETED: 'blockjam_sign_in_completed',
    SIGN_IN_CANCELLED: 'blockjam_sign_in_cancelled',
    SIGN_IN_FAILED: 'blockjam_sign_in_failed',
    // WP-126.6 — same section.
    SIGN_IN_PROMPT_SHOWN: 'blockjam_sign_in_prompt_shown',
    WELCOME_GIFT_GRANTED: 'blockjam_welcome_gift_granted',
};
